import type { TFunction } from "i18next";
import type { FieldError } from "react-hook-form";

function extractErrorString(
  t: TFunction<"translation", undefined>,
  error?: FieldError | string
): string | undefined {
  if (error === undefined || error === "") {
    return undefined;
  }

  if (typeof error === "string") {
    return error;
  }

  if (error.message) {
    return error.message;
  }

  if (error.type) {
    return t(
      `errors.${error.type.charAt(0).toUpperCase() + error.type.slice(1)}`
    );
  }

  return t("errors.UnknownError");
}

export { extractErrorString };
